module.exports = __webpack_public_path__ + "static/media/IDIA.f5fb7e82.svg";